import { Link, useNavigate } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from "../Footer/Footer";
import icon02 from "../../../screenassets/images/cta/02.png";
import { useCallback, useEffect, useState } from 'react';
import { ToastContainer, toast } from "react-toastify";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import md5 from 'md5';
import { fetchUsers } from '../../../service/slice/AuthSlice';
import { useDispatch } from 'react-redux';


export default function Signup() {

    const [full_name, setFullName] = useState('');
    const [last_name, setLastName] = useState('');
    const [email_phone, setEmailPhone] = useState('');
    const [password, setPassword] = useState('');
    const [referralCode, setReferralCode] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [board, setBoard] = useState([]);
    const [othersBoard, setOthersBoard] = useState({
        type: "",
        value: ""
    });
    const [languages, setLanguages] = useState([]);
    const [othersLanguages, setOthersLanguages] = useState([]);
    const [level, setlevel] = useState();
    const [othersSubject, setOthersSubject] = useState([]);
    const [isChecked, setIsChecked] = useState(false);

    const navigate = useNavigate();
    const adminToken = localStorage.getItem("authAdminToken");
    const animatedComponents = makeAnimated();

    const dispatch = useDispatch();

    // Check if value looks like an email
    const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email_phone);

    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const signupData = {
            first_name: full_name,
            last_name: last_name,
            email: email_phone,
            password: password,
            subject: JSON.stringify(othersSubject.map((elem) => elem.value)),
            medium: JSON.stringify(othersLanguages.map((elem) => elem.value)),
            referralcode: referralCode,
            board: othersBoard.value,
            level: level
        };

        function validateEmail(email) {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            return emailRegex.test(email);
        }

        function isValidPhoneNumber(phone) {
            const regex = /^\d{10}$/;
            return regex.test(phone);
        }

        function validatePassword(password) {
            const re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
            return re.test(password);
        };

        if (validateEmail(email_phone) && isValidPhoneNumber(email_phone)) {
            toast.error("Please enter valid email or phone number.");
            return;
        }

        if (!full_name) {
            toast.info("First name Field is required!");
            return;
        }
        if (!last_name) {
            toast.info("Last name Field is required!");
            return;
        }
        if (!validatePassword(password)) {
            toast.info("Password must be at least 8 characters, include uppercase, lowercase, number, and special character!");
            return;
        }
        if (!othersLanguages.length > 0) {
            toast.info("language Field is required!");
            return;
        }
        if (!level) {
            toast.info("Level Field is required!");
            return;
        }
        if (!isChecked) {
            toast.info("Please accept terms and conditions!");
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/register`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(signupData),
            });
            const data = await response.json();

            if (data.status === true) {
                toast.success("OTP sent! Please verify.");
                navigate('/RegisterValidateOtp', { state: signupData });
            } else if (data.verified == "optresend") {
                toast.info("User registered but OTP is not validate. Redirecting to OTP page...");
                setTimeout(() => {
                    navigate('/RegisterValidateOtp', { state: signupData });
                }, 1500);
            } else {
                toast.error("User already registered. Please sign in.");
                setTimeout(() => {
                    navigate('/signin');
                }, 2000);
            }

        } catch (error) {
            toast.error("Something went wrong! Please try again later.");
        }

    }

    // Fetch All Language
    const fetchLang = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/service/getAllLanguage`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${adminToken}`
            },
        });
        return response.json();
    };

    // Fetch All Study Profile
    const fetchStudyProfile = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/service/getStudyProfile`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${adminToken}`
            },
        });
        return response.json();
    };

    useEffect(() => {
        fetchStudyProfile().then((res) => {
            if (res.status) {
                setBoard(res?.studyProfile)
            } else {
                toast.error("Failed to load languages. Please try again.");
            }
        }).catch((error) => {
            toast.error("Unable to fetch languages at the moment.");
        });

        fetchLang().then((res) => {
            if (res.status) {
                setLanguages(res?.languages)
            } else {
                toast.error("Failed to load languages. Please try again.");
            }
        }).catch((error) => {
            toast.error("Unable to fetch languages at the moment.");
        });
    }, []);

    const handleSigninGoogle = async (email, password) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/login`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email,
                    password
                }),
            });
            return response.json();

        } catch (error) {
            toast.error("An error occurred. Please try again later.");
        }
    }
    const handleSignUpGoogle = async (userDetails) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/registerPartials`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    first_name: userDetails.first_name,
                    last_name: userDetails.last_name,
                    email: userDetails.email,
                    password: userDetails.password
                }),
            });
            return response.json();

        } catch (error) {
            toast.error("An error occurred. Please try again later.");
        }
    }

    const onSuccess = (credentialResponse) => {
        const user = jwtDecode(credentialResponse.credential);
        var userDetails = {
            first_name: user?.given_name,
            last_name: user?.family_name,
            email: user?.email,
            password: md5(user?.sub)
        }

        handleSigninGoogle(userDetails.email, userDetails.password).then((data) => {
            if (data.status === true) {
                toast.success("Signin successful!");
                localStorage.setItem("authToken", data.token);
                dispatch(fetchUsers({ token: data.token, type: "user" }))
                window.location.href = "/user/dashboard";
            } else {
                if (data.userVerified === "notverified") {
                    handleSignUpGoogle(userDetails).then((res) => {
                        const userEmail = userDetails.email;
                        const OTP = res.otp
                        if (res.status) {
                            navigate('/googleVerified', { state: { email: userEmail, otp: OTP } });
                        }
                    }).catch((error) => {

                    })
                } else if (data.userVerified === "detailsnotverified") {
                    const OTP = data.otp
                    const userEmail = userDetails.email;
                    navigate('/googleVerified', { state: { email: userEmail, otp: OTP } });
                }
                //navigate("/googleVerified");
            }
        }).catch((err) => {

        })


    };

    const onFailure = (error) => {
        console.log('Login Failed:', error);
        // Handle login failure
    };



    return (
        <>
            {/* Header Section */}
            <Header />

            <div className="rts-bread-crumb-area bg_image">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb-inne">
                                <div className="title-area">
                                    <h1 className="bread-title">Register</h1>
                                    <div className="inner-wrapper">
                                        <Link to="/">Home</Link>/
                                        <Link to="#" className="active">Register</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Toast container */}
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

            {/* Form Section */}
            <div className="rts-register-area rts-section-gap">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">

                            <div className="single-form-s-wrapper">
                                <div className="head">
                                    <span>Start your Journey</span>
                                    <h5 className="title">Create an account</h5>
                                </div>
                                <div className="body">
                                    <form onSubmit={(event) => { handleSubmit(event) }}>
                                        <div className="input-wrapper">
                                            <input type="text" id='full_name' name='full_name' value={full_name} onChange={(event) => { setFullName(event.target.value) }} placeholder="First Name" Style="border:none !important" required />
                                        </div>

                                        <div className="input-wrapper mt-3">
                                            <input type="text" value={last_name} onChange={(event) => { setLastName(event.target.value) }} placeholder="Last Name" Style="border:none !important" required />
                                        </div>

                                        <div className="input-wrapper mt-4">
                                            <input type="email" id='email_phone' name='email_phone' value={email_phone} onChange={(event) => { setEmailPhone(event.target.value) }} placeholder="Email" Style="border:none !important" required />
                                        </div>

                                        <div className="input-wrapper mt-4">
                                            <select value={othersBoard.value} onChange={(event) => { setOthersBoard({ value: event.target.value == "Others" ? "" : event.target.value, type: event.target.value }); if (event.target.value !== "Others") { var selectMedium = JSON.parse(board.filter((elem) => elem.board == event.target.value)[0].medium); setOthersLanguages([...othersLanguages, ...selectMedium.map((elem) => { return { value: elem, label: elem } })]) } else { setOthersLanguages([]) } }} required>
                                                <option value="">Select Board</option>
                                                {board.map((study, idx) => {
                                                    return <option key={idx} value={study.board}>{study.board}</option>
                                                })
                                                }
                                                <option value="Others">Others Board</option>
                                            </select>
                                        </div>

                                        {othersBoard.type == "Others" && (
                                            <div className="input-wrapper mt-4">
                                                <input type="text" value={othersBoard.value} onChange={(event) => { setOthersBoard({ ...othersBoard, value: event.target.value }) }} placeholder="Board Name" Style="border:none !important" required />
                                            </div>
                                        )}

                                        { /* Language Section */}
                                        <Select
                                            className='mt-3'
                                            closeMenuOnSelect={false}
                                            components={animatedComponents}
                                            // defaultValue={othersLanguages}
                                            value={othersLanguages}
                                            isMulti
                                            options={[...languages.map((lang, index) => ({ value: lang.language, label: lang.language })), { value: "Others Language", label: "Others Language" }]}
                                            onChange={(value) => { setOthersLanguages(value) }}
                                            placeholder={<div className='d-flex p-0' Style="width: 150px !important;">Select Medium</div>}
                                        />

                                        {othersLanguages.filter((elem) => elem.label == "Others Language").length > 0 && (
                                            <div className="input-wrapper mt-4">
                                                <input type="text" placeholder="Other Language" Style="border:none !important" onChange={(event) => { const data = structuredClone(othersLanguages); data.map((elem) => { if (elem.label == "Others Language") { elem.value = event.target.value }; return elem; }); setOthersLanguages(data) }} required />
                                            </div>
                                        )}


                                        { /* Subject Section */}
                                        {/* <Select
                                            className='mt-3'
                                            closeMenuOnSelect={false}
                                            components={animatedComponents}
                                            defaultValue={othersSubject}
                                            isMulti
                                            options={[...subject.map((sub, index) => ({ value: sub.subject, label: sub.subject })), { value: "Others Subject", label: "Others Subject" }]}
                                            onChange={(value) => { setOthersSubject(value) }}
                                            placeholder={<div className='d-flex p-0' Style="width: 150px !important;">Select Subject</div>}
                                        />

                                        {othersSubject.filter((elem) => elem.label == "Others Subject").length > 0 && (
                                            <div className="input-wrapper mt-4">
                                                <input type="text" placeholder="Enter Your Other Subject" Style="border:none !important" onChange={(event) => { const data = structuredClone(othersSubject); data.map((elem) => { if (elem.label == "Others Subject") { elem.value = event.target.value }; return elem; }); setOthersSubject(data) }} required />
                                            </div>
                                        )} */}


                                        <div className="input-wrapper mt-4">
                                            <select value={level} onChange={(event) => { setlevel(event.target.value) }} required>
                                                <option value="">Select Level</option>
                                                <option value="6-8">6-8</option>
                                                <option value="9-10">9-10</option>
                                                <option value="11-12">11-12</option>

                                            </select>
                                        </div>

                                        <div className="input-wrapper mt-4">
                                            <input type={showPassword ? "text" : "password"} id='password' name='password' value={password} onChange={(event) => { setPassword(event.target.value) }} placeholder="Password" className="pr-10" Style="border:none !important" />

                                            {/* Toggle button */}
                                            <button type="button" onClick={() => setShowPassword(!showPassword)} className="passwordShow">
                                                {showPassword ? <IoEyeOffOutline /> : <IoEyeOutline />}
                                            </button>
                                        </div>

                                        <div className="input-wrapper mt-4">
                                            <input type="text" value={referralCode} onChange={(event) => { setReferralCode(event.target.value) }} placeholder="Referral Code (Optional)" Style="border:none !important" />
                                        </div>


                                        <div className="check-wrapper">
                                            <div className="form-check">
                                                <input className="form-check-input d-none" type="checkbox" checked={isChecked} onChange={handleCheckboxChange} id="flexCheckDefault" />
                                                <label className="form-check-label" htmlFor="flexCheckDefault">
                                                    Accept <Link data-bs-toggle="modal" data-bs-target="#staticBackdrop">Terms & Condition</Link>
                                                </label>
                                            </div>
                                        </div>

                                        <button type='submit' className="rts-btn btn-primary text-white">Create Account</button>
                                        <p>
                                            If you have an account?
                                            <Link className="ml--5" to="/signin">Sign in</Link>
                                        </p>
                                    </form>
                                </div>

                                <div className="other-separator">
                                    <span>or</span>
                                </div>

                                <div className="sign-in-otherway">
                                    <GoogleLogin onSuccess={onSuccess} onError={onFailure} />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>



            <div className="rts-cta-area rts-section-gapBottom bg_faq">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="cta-main-wrapper bg_image">
                                <div className="left">
                                    <h3 className="title">
                                        All set to level up <br />
                                        your content game?
                                    </h3>
                                    <Link to="/about" className="rts-btn btn-primary">Get Started Now</Link>
                                </div>
                                <div className="right">
                                    <img src={icon02} alt="cta-area" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title fs-5" id="staticBackdropLabel">Modal title</h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <header>
                                <h1>Terms &amp; Conditions</h1>
                                <p class="muted">Effective date: <strong>[Effective Date]</strong> — For: <strong>[Platform Name]</strong></p>
                            </header>


                            <section>
                                <h2>1. Introduction</h2>
                                <p>These Terms &amp; Conditions ("Terms") govern your access to and use of the AI-based question solving platform operated by <strong>[Platform Name]</strong> ("we", "us", "the Platform"). By using the Platform you agree to these Terms. If you do not agree, do not use the Platform.</p>
                            </section>


                            <section>
                                <h2>2. Definitions</h2>
                                <ul>
                                    <li><strong>Student / User:</strong> a person who accesses or uses the Platform.</li>
                                    <li><strong>Package:</strong> a paid subscription, bundle, or credit pack that grants access to additional features beyond the free allowance.</li>
                                    <li><strong>Request:</strong> a single submission to the Platform asking the AI to solve, explain, or generate an answer for one question or problem.</li>
                                </ul>
                            </section>


                            <section>
                                <h2>3. Free Usage — 3 Free Requests</h2>
                                <p class="highlight">Unregistered or non-purchased users are entitled to <strong>three (3) free requests</strong> total. After exhausting these free requests, further use of the Platform requires purchasing a Package or creating an account as described below.</p>
                                <ol>
                                    <li>Free requests are tracked per-user via cookies and/or account identifier (if any). We reserve the right to limit or reset tracking to prevent abuse.</li>
                                    <li>Free requests are intended for trial and evaluation only and may be subject to lower priority, rate limits, or reduced feature access compared to paid Packages.</li>
                                    <li>We may change the number or nature of free requests at our discretion; continued use of the Platform after such change constitutes acceptance of the change.</li>
                                </ol>
                            </section>


                            <section>
                                <h2>4. Paid Packages, Billing &amp; Access</h2>
                                <ol>
                                    <li>Packages: Paid Packages grant access to a specified number of requests, higher priority processing, or additional features described on the Platform's pricing page.</li>
                                    <li>Payment: All fees are charged in the currency shown at checkout. Payment methods accepted are displayed at the time of purchase.</li>
                                    <li>Auto-renewal: If a Package is subscription-based, it will renew automatically at the end of each billing cycle unless cancelled by the User before renewal. You may cancel subscription auto-renewal from your account settings.</li>
                                    <li>No transfer: Credits, requests, or access included with a Package are non-transferable unless explicitly stated otherwise.</li>
                                </ol>
                            </section>


                            <section>
                                <h2>5. Refund &amp; Cancellation Policy</h2>
                                <ol>
                                    <li>Refunds: Refund eligibility (if any) depends on the Package purchased and the jurisdiction. Unless otherwise provided, purchases are non-refundable after requests have been consumed or if the Platform has delivered the paid service.</li>
                                    <li>How to cancel: To cancel a subscription or stop auto-renewal, follow the cancellation steps in your account or contact us at <a href="mailto:[support@example.com]">[support@example.com]</a>.</li>
                                </ol>
                            </section>


                            <section>
                                <h2>6. Use of AI-Generated Solutions</h2>
                                <ol>
                                    <li>Accuracy: AI-generated solutions are provided for educational purposes only. We do not guarantee that any solution is correct, complete, or suitable for any particular purpose.</li>
                                    <li>Verification: Students must verify solutions before relying on them for exams, assignments, or any graded work. Using Platform output as-is for academic submissions may violate your institution's policies — you are responsible for complying with those policies.</li>
                                    <li>Plagiarism: The Platform's outputs may resemble existing content. It is the User's responsibility to ensure proper citation and to avoid plagiarism when required by academic rules.</li>
                                </ol>
                            </section>


                            <section>
                                <h2>7. Intellectual Property</h2>
                                <ol>
                                    <li>Ownership: The Platform and its content, including AI models, code, designs, and documentation, are owned or licensed by the Platform.</li>
                                    <li>User submissions: By submitting questions, you grant us a worldwide, royalty-free, non-exclusive license to use the submitted content to provide, improve, and analyze the Platform's services. We will not publish personally-identifying information without consent except as required by law.</li>
                                </ol>
                            </section>


                            <section>
                                <h2>8. Prohibited Conduct</h2>
                                <p>Users must not use the Platform to:</p>
                                <ul>
                                    <li>Attempt to reverse-engineer the AI or its outputs.</li>
                                    <li>Use automated scripts to bypass the free-request limits or otherwise manipulate the service.</li>
                                    <li>Submit content that is unlawful, harmful, discriminatory, or violates others' rights.</li>
                                </ul>
                            </section>


                            <section>
                                <h2>9. Suspension, Termination &amp; Abuse</h2>
                                <p>We reserve the right to suspend or terminate access for users who violate these Terms or engage in abusive behaviour. In cases of fraud or abuse, we may revoke free requests, cancel Packages, or refer the matter to appropriate authorities. We are not liable for any losses from such enforcement actions.</p>
                            </section>


                            <section>
                                <h2>10. Disclaimers &amp; Limitation of Liability</h2>
                                <ol>
                                    <li>DISCLAIMER: THE PLATFORM IS PROVIDED "AS IS" AND "AS AVAILABLE". TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.</li>
                                    <li>LIMITATION OF LIABILITY: TO THE MAXIMUM EXTENT PERMITTED BY LAW, OUR AGGREGATE LIABILITY ARISING OUT OF OR RELATED TO THESE TERMS OR THE PLATFORM SHALL NOT EXCEED THE AMOUNTS PAID BY YOU IN THE PRIOR 12 MONTHS (IF ANY). WE ARE NOT LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES.</li>
                                </ol>
                            </section>


                            <section>
                                <h2>11. Privacy &amp; Data</h2>
                                <p>Your use of the Platform is also governed by our <a href="[Privacy Policy URL]">Privacy Policy</a>. We collect and process certain information (such as device identifiers, cookies, and content submitted by you) to operate and improve the Platform. Please review the Privacy Policy for details about data retention, deletion, and your privacy rights.</p>
                            </section>


                            <section>
                                <h2>12. Changes to Terms</h2>
                                <p>We may revise these Terms from time to time. We will provide notice of material changes via the Platform or email. Continued use after notice constitutes acceptance of the updated Terms.</p>
                            </section>


                            <section>
                                <h2>13. Governing Law &amp; Dispute Resolution</h2>
                                <p>These Terms are governed by the laws of <strong>[Jurisdiction — e.g., State/Country]</strong> without regard to conflict-of-law rules. Any dispute arising from these Terms will be resolved in the courts located in <strong>[City, State/Country]</strong>, unless otherwise agreed in writing.</p>
                            </section>

                            <section>
                                <h2>14. Contact</h2>
                                <p>If you have questions about these Terms, contact us at:</p>
                                <div>
                                    <strong>[Platform Name]</strong><br />
                                    Email: <a href="mailto:[support@example.com]">[support@example.com]</a><br />
                                    Address: [Company Address — optional]
                                </div>
                            </section>

                            <footer>
                                <p class="muted">Last updated: <strong>[Last Updated Date]</strong>. Please read these Terms carefully. Your access and use are conditioned on accepting and complying with them.</p>
                            </footer>
                        </div>
                    </div>
                </div>
            </div>
            {/* Footer Section */}
            <Footer />

        </>
    )
}
